import * as React from "react";
import { useTranslation } from "react-i18next";
import CommonContainer from "../../../components/common/container/CommonContainer";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import useSnackbarAlert from '../../../utils/snackbarHandlers';
import { AdvertisementsForm } from "../../../components";
import { LinearProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";

const initialData = {
  productTitle: "",
  productPriceDescription: "",
  adLocation: "",
  image: "",
};

const EditAdvertisement: React.FC = () => {
  const { t } = useTranslation('translation');
  const { id } = useParams();
  //@ts-ignore
  const config = window.config;
  const apiBaseURL = config?.server || 'http://18.217.95.31:8080';
  const { showErrorMessage, showSuccessMessage } = useSnackbarAlert();
  const [adData, setAdData] = React.useState<any>(initialData);
  const [loading, setLoading] = React.useState<boolean>(false);
  const navigate = useNavigate();
  const uId = JSON.parse(localStorage.getItem('UserData') || "");

  React.useEffect(() => {
    setLoading(true);
    axios.get(`${apiBaseURL}/api/advertisement/getParticularAdvertisementDetails?id=${id}`).then((res: any) => {
      if (res?.status === 200) {
        setAdData(res?.data?.advertisementInformation)
      } else setAdData({})
    })
      .catch((err: any) => showErrorMessage(err))
      .finally(() => setLoading(false))
  }, [])

  const onSubmit = (value: any) => {
    const fileHeaders = {
      accept: "application/json",
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "multipart/form-data",
    };
    const body = {
      productTitle: value.productTitle,
      productPriceDescription: value.productPriceDescription,
      adLocation: value.adLocation,
      image: value.image,
      lastUpdatedBy: uId ? uId?.uId : "",
    };

    axios
      .put(`${apiBaseURL}/api/advertisement/update?id=${id}`, body, { headers: fileHeaders })
      .then((data: any) => {
        if (data?.status === 200) {
          showSuccessMessage(t("adUpdatedSuccessfully", "Advertisement Updated Successfully"))
          navigate('/shopOwner/advertisements');
        }
      })
      .catch((err: any) =>
        showErrorMessage(t("somethingWentWrong"))
      )
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <CommonContainer title={t("editAdPageTitle")} description={t("editAdPageDescription")}>
      {loading ? <LinearProgress /> : <AdvertisementsForm adsData={adData} edit={true} formSubmit={onSubmit} />}
    </CommonContainer>
  );
};

export default EditAdvertisement;
